import { AbstractStandardTableToolsPanel } from "./AbstractStandardTableToolsPanel";
import { EllipsisActionsButton } from "./buttons/EllipsisActionsButton";

enum InnerIds {
    BUTTON_ELLIPSIS_ACTIONS = "buttonEllipsisActions"
}

export class EllipsisActionsPanel extends AbstractStandardTableToolsPanel {
    private buttonEllipsisActions: EllipsisActionsButton;

    override syncInnerComponentIds() {
        this.setInnerComponentId(this.buttonEllipsisActions.get(), InnerIds.BUTTON_ELLIPSIS_ACTIONS);
    }

    override createComponents() {
        this.buttonEllipsisActions = new EllipsisActionsButton(this.table, this.commonButtonProps);
        this.buttonEllipsisActions.get().id = this.createInnerComponentId(InnerIds.BUTTON_ELLIPSIS_ACTIONS);
    }

    override sync() {
        this.removeAll();
        this.addTool(this.shouldShowEllipsisActionsButton(), this.buttonEllipsisActions?.get());
    }

    private shouldShowEllipsisActionsButton(): boolean {
        return this.table.allowConfig || this.table.allowPin || this.table.allowExport;
    }

    override getPopulatedPaddingLeft(): number {
        return 4;
    }

    override getPopulatedPaddingRight(): number {
        return 4;
    }
}
